import { c as _c } from "react/compiler-runtime";
import { twMerge } from "tailwind-merge";
import { defaultInputLabelStyles, InputLabelStyleProps, inputLabelStylesMap } from "@/components/global/form/inputs/styles/input-label.styles";
interface InputLabelProps {
  htmlFor: string;
  label: React.ReactNode;
  required?: boolean;
  styles?: InputLabelStyleProps;
  onClick?: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
}

/**
 * Form field label component
 * @param {string} htmlFor - Associated field ID
 * @param {string} label - Label text
 * @param {boolean} [required] - If true, displays a red asterisk
 * @param {InputLabelStyleProps} [styles] - Custom styles for the label
 * @param {() => void} [onClick] - Click handler for the label
 * @param {() => void} [onFocus] - Focus handler for the label
 * @param {() => void} [onBlur] - Blur handler for the label
 * @example
 * <InputLabel
 *   htmlFor="email"
 *   label="Email"
 *   required
 *   styles={{
 *     textColor: "primary",
 *     fontSize: "md",
 *     marginBottom: "lg"
 *   }}
 * />
 */
export const InputLabel = t0 => {
  const $ = _c(15);
  const {
    htmlFor,
    label,
    required,
    styles: t1,
    onClick,
    onFocus,
    onBlur
  } = t0;
  let t2;
  let t3;
  if ($[0] !== htmlFor || $[1] !== onClick || $[2] !== t1) {
    const styles = t1 === undefined ? {} : t1;
    const mergedStyles = {
      ...defaultInputLabelStyles,
      ...styles
    };
    t2 = htmlFor;
    t3 = twMerge(inputLabelStylesMap.fontSize[mergedStyles.fontSize], inputLabelStylesMap.marginBottom[mergedStyles.marginBottom], inputLabelStylesMap.fontWeight[mergedStyles.fontWeight], `text-${mergedStyles.textColor}`, mergedStyles.className, onClick && "cursor-pointer");
    $[0] = htmlFor;
    $[1] = onClick;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== required) {
    t4 = required && <span className="text-primary">*</span>;
    $[5] = required;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== label || $[8] !== onBlur || $[9] !== onClick || $[10] !== onFocus || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <label htmlFor={t2} className={t3} onClick={onClick} onFocus={onFocus} onBlur={onBlur}>{label} {t4}</label>;
    $[7] = label;
    $[8] = onBlur;
    $[9] = onClick;
    $[10] = onFocus;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};